import React from 'react';
import Icon from 'components/Icon';
import classNames from 'classnames';

import './style.css';

const ConversationCard = ({
	conversationId,
	conversationSubject,
	toName,
	lastMessage,
	date,
	notification,
	isSelected = false,
	handleConversationClick,
	unReadMessagesCount,
	Resolved,
}) => {
	const className = classNames('ConversationCard', { selected: isSelected, resolved: Resolved });
	const iconName = isSelected && !Resolved ? 'selectedAvatarIcon' : Resolved ? 'lockIcon' : 'avatarIcon';

	const passConversationId = () => {
		conversationId && handleConversationClick(conversationId);
	};

	// const message = lastMessage.replace(/\n/g, ' ');

	return (
		<div className={className} onClick={passConversationId}>
			<div className="ConversationCard__wrapper">
				<div className="ConversationCard__icon">
					<Icon icon={iconName} size="62" />
				</div>
				<div className="ConversationCard__header">
					<div className="ConversationCard__header__name">{conversationSubject}</div>
					<div className="ConversationCard__header__status">
						{/* {Resolved && (
							<div className="ConversationCard__notification">
								<Icon icon="lockIcon" />
							</div>
						)} */}
						{notification && <div className="ConversationCard__notification">{unReadMessagesCount}</div>}
					</div>
				</div>
				<div className="ConversationCard__properties">
					<div className="ConversationCard__properties__toUser">{toName}</div>
					{/* <div className="ConversationCard__properties__lastMessage">{message}</div> */}
				</div>
			</div>
			<div className="ConversationCard__date">
				{date.toLocaleString('en-US', {
					year: 'numeric',
					month: 'numeric',
					day: 'numeric',
					hour: 'numeric',
					minute: '2-digit',
					hour12: true,
				})}
			</div>
		</div>
	);
};

export default ConversationCard;
